import { createAction, props } from '@ngrx/store';
import { ErrorInterface } from '../../interfaces/general.interface';

enum SetPasswordActionType {
  setPassword = '[set password] set Password',
  requestSuccess = '[set password] success change Password',
  requestError = '[set password] error change Password',
  clearPassword = '[set password] clear change Password',
}

export const setPassword = createAction(
  SetPasswordActionType.setPassword,
  props<{ password: any; token: any }>()
);

export const requestSuccess = createAction(
  SetPasswordActionType.requestSuccess,
  props<{ response: any }>()
);

export const requestError = createAction(
  SetPasswordActionType.requestError,
  props<{ error: ErrorInterface }>()
);

export const clearPassword = createAction(SetPasswordActionType.clearPassword);
